// extracted by mini-css-extract-plugin
export default {"container":"PrivacyNotice_container__mqWPY","header":"PrivacyNotice_header__-yoGD"};